import * as actionTypes from "../actions/actionTypes";

const initialState = {
  storages: null,
  isYamato: false,
  error: false,
  loading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_STORAGE:
      return {
        ...initialState,
      };

    case actionTypes.SET_DEPOSITS:
      return {
        ...state,
        storages: Array.isArray(action.storages) ? action.storages : [],
        error: false,
        loading: false,
        isYamato:
          Array.isArray(action.storages) &&
          action.storages.some((storage) => storage.company_brand === "Yamato"),
      };
    case actionTypes.FETCH_DEPOSITS_FAILED:
      return {
        ...state,
        error: action.error || true,
        loading: false,
      };
    case actionTypes.FETCH_DEPOSITS_STARTING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    default:
      return state;
  }
};

export default reducer;
